import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { WhatsAppIcon, LinkedInIcon, XIcon, LinkIcon } from './icons/SocialIcons';

export default function ShareButtons({ url, title }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const text = encodeURIComponent(title || 'Napho - Market Pulse');
  const enc = encodeURIComponent(shareUrl);

  const targets = [
    { name: 'WhatsApp', href: `https://wa.me/?text=${text}%20${enc}`, Icon: WhatsAppIcon },
    { name: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`, Icon: LinkedInIcon },
    { name: 'X', href: `https://twitter.com/intent/tweet?text=${text}&url=${enc}`, Icon: XIcon },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url: shareUrl });
      } catch {
      }
    }
  };

  return (
    <div className="share">
      <span className="share__label">
        {copied ? t('share.copied') : t('share.label')}
      </span>
      {typeof navigator !== 'undefined' && navigator.share && (
        <button className="share__btn" onClick={nativeShare} aria-label="Share" title="Share">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
            <circle cx="18" cy="5" r="3" />
            <circle cx="6" cy="12" r="3" />
            <circle cx="18" cy="19" r="3" />
            <line x1="8.6" y1="10.5" x2="15.4" y2="6.5" />
            <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
          </svg>
        </button>
      )}
      {targets.map(({ name, href, Icon }) => (
        <a
          key={name}
          className="share__btn"
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={`Share on ${name}`}
          title={name}
        >
          <Icon />
        </a>
      ))}
      <button className="share__btn" onClick={copy} aria-label="Copy link" title="Copy link">
        <LinkIcon />
      </button>
    </div>
  );
}
